import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaWhatsapp } from 'react-icons/fa';
import { IoClose } from 'react-icons/io5';

const WhatsAppButton = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const whatsappNumber = '9892550941'; // Your WhatsApp number
  const message = encodeURIComponent('Hi! I am interested in your products on Fluteon.');
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${message}`;

  const handleClick = () => {
    window.open(whatsappLink, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      {/* WhatsApp Button */}
      <motion.div
        className="fixed bottom-6 right-6 z-50 flex flex-col items-end"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.5, type: 'spring', stiffness: 260, damping: 20 }}
      >
        {/* Tooltip */}
        {showTooltip && (
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            className="mb-3 mr-3 bg-white dark:bg-gray-800 shadow-lg rounded-lg px-4 py-3 relative"
          >
            <button
              onClick={() => setShowTooltip(false)}
              className="absolute -top-1 -right-1 bg-gray-200 dark:bg-gray-700 rounded-full p-1 hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors"
            >
              <IoClose className="text-gray-600 dark:text-gray-300 text-sm" />
            </button>
            <p className="text-sm font-medium text-gray-800 dark:text-gray-200 pr-4">
              Need help? Chat with us!
            </p>
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
              We typically reply instantly
            </p>
            <div className="absolute -bottom-2 right-6 w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-white dark:border-t-gray-800"></div>
          </motion.div>
        )}

        {/* Main WhatsApp Button */}
        <motion.button
          onClick={handleClick}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          className="group relative w-16 h-16 rounded-full shadow-2xl flex items-center justify-center cursor-pointer overflow-hidden"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          style={{
            background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)',
          }}
        >
          {/* Animated Ripple Effect */}
          <motion.div
            className="absolute inset-0 rounded-full"
            style={{
              background: 'radial-gradient(circle, rgba(255,255,255,0.3) 0%, transparent 70%)',
            }}
            animate={{
              scale: [1, 1.5, 1],
              opacity: [0.5, 0, 0.5],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut',
            }}
          />

          {/* WhatsApp Icon */}
          <FaWhatsapp className="text-white text-3xl z-10 group-hover:scale-110 transition-transform duration-300" />

          {/* Glow Effect on Hover */}
          <div className="absolute inset-0 rounded-full bg-white opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
        </motion.button>

        {/* Notification Badge (Optional) */}
        <motion.div
          className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center"
          initial={{ scale: 0 }}
          animate={{ scale: [0, 1.2, 1] }}
          transition={{ delay: 1, duration: 0.5 }}
        >
          1
        </motion.div>
      </motion.div>

      {/* Pulsing Background Circle */}
      <motion.div
        className="fixed bottom-6 right-6 w-16 h-16 rounded-full z-40 pointer-events-none"
        style={{
          background: 'radial-gradient(circle, rgba(37, 211, 102, 0.4) 0%, transparent 70%)',
        }}
        animate={{
          scale: [1, 1.3, 1],
          opacity: [0.6, 0.2, 0.6],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />
    </>
  );
};

export default WhatsAppButton;
